(() => {
  if (customElements.get('animate-boxes')) {
    return;
  }

  class AnimateBoxes extends HTMLElement {
    constructor() {
      super();
      this.isAnimated = false;
    }

    connectedCallback() {
      this.setupScrollListener();
    }

    setupScrollListener() {
      window.addEventListener('scroll', this.checkPosition.bind(this));
      // Initial check in case the element is already in view on page load
      this.checkPosition();
    }

    checkPosition() {
      if (this.isAnimated) return;

      const rect = this.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      // Adjust this value to change when the animation triggers
      const triggerPoint = windowHeight * 0.8;

      if (rect.top <= triggerPoint) {
        this.initAnimate();
        this.isAnimated = true;
        window.removeEventListener('scroll', this.checkPosition.bind(this));
      }
    }

    initAnimate() {
      this.classList.add('is-animate');
    }
  }

  customElements.define('animate-boxes', AnimateBoxes);
})();
